import { render, staticRenderFns } from "./PageSlide.vue?vue&type=template&id=1a86d348&scoped=true&"
import script from "./PageSlide.vue?vue&type=script&lang=js&"
export * from "./PageSlide.vue?vue&type=script&lang=js&"
import style0 from "./PageSlide.vue?vue&type=style&index=0&id=1a86d348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86d348",
  null
  
)

export default component.exports